import { useLocation } from "react-router-dom";

import { Body, BodySmall } from "@components/Typography";
import { useErrorBanner, useModal, useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";
import { ShareGoalRouteParams } from "@routes/ShareGoalRoute/types";
import { getFullName, getInitials } from "@utils";
import { RemoveContributorModal } from "./RemoveContributorModal";
import { useStyles } from "./styles";
import { ContributorItemProps } from "./types";

export const ContributorItem = ({
  firstName,
  lastName,
  partnerId,
  color: colorProp,
}: ContributorItemProps) => {
  const { theme } = useTheme();
  const styles = useStyles();
  const { showErrorBanner } = useErrorBanner();
  const { show } = useModal();

  const location = useLocation();
  const goalId = (location.state as ShareGoalRouteParams).goalId;

  const color = colorProp ?? theme.contact.item1;

  const initials = getInitials(firstName, lastName);
  const name = getFullName(firstName, lastName);

  const handleRemove = () => {
    if (!partnerId) return showErrorBanner();

    show(<RemoveContributorModal name={name} partnerId={partnerId} goalId={goalId} />);
  };

  return (
    <div style={styles.container}>
      <div style={styles.left}>
        <div style={{ ...styles.logo, ...{ backgroundColor: color } }}>
          <BodySmall style={styles.initials}>{initials}</BodySmall>
        </div>
        <Body style={styles.name}>{name}</Body>
      </div>
      <div style={styles.right}>
        <BodySmall style={styles.cta} onClick={handleRemove}>
          {i18n.t(Translations.ContributorItemRemoveLabel)}
        </BodySmall>
      </div>
    </div>
  );
};
